<template>
  <div class="xiazai-box" v-if="show" @click="show = false">
  	<div class="xiazai-box-model" @click.stop>
  		<div class="app-box-ewm">
  			<div class="app-box-ewm-item">
  				<div class="app-box-ewm-item-img">
  					<img src="../../assets/image/ewm.png" alt="" />
  				</div>
  				<div class="app-box-ewm-item-des">国际安卓下载</div>
  				<div class="app-box-ewm-item-div">
  					<img src="../../assets/image/anzhuo.png" alt="" />
  					<div class="app-box-ewm-item-div-content">
  						<span class="app-box-ewm-item-div-content-span">GET IN ON</span>
  						<span class="app-box-ewm-item-div-content-span1">安卓下载</span>
  					</div>
  				</div>
  			</div>
  			<div class="app-box-ewm-item">
  				<div class="app-box-ewm-item-img">
  					<img src="../../assets/image/ewm.png" alt="" />
  				</div>
  				<div class="app-box-ewm-item-des">国际苹果下载</div>
  				<div class="app-box-ewm-item-div">
  					<img src="../../assets/image/pingguo.png" alt="" />
  					<div class="app-box-ewm-item-div-content">
  						<span class="app-box-ewm-item-div-content-span">Download on the</span>
  						<span class="app-box-ewm-item-div-content-span1">苹果下载</span>
  					</div>
  				</div>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
	  show:false,
    };
  },
  mounted() {
	
  },
  methods: {
	showModel(data){
		this.show = true
	},

  }
};
</script>
<style scoped lang="scss">
	@import "./xiazai.css";
</style>


// WEBPACK FOOTER //
// xiazai.vue?8c60e0f6